<template>
  <div>
    <Transition>
      <ScrollToTopBtn v-show="scrollBtn"></ScrollToTopBtn
    ></Transition>

    <img v-if="false" src="@/assets/images/vap-logo-preview.jpg" alt="" />
    <HeaderMobile v-if="viewStore.isMobile"></HeaderMobile>
    <Header v-else></Header>

    <Slogan v-if="!viewStore.isMobile" style="margin-top: -60px"></Slogan>
    <Trustgainer></Trustgainer>
    <Pricing class="shadow-lg"></Pricing>
    <Promise></Promise>
    <CompetenceMobile v-if="viewStore.isMobile"></CompetenceMobile>
    <Competence v-if="!viewStore.isMobile"></Competence>
    <Reference2></Reference2>
    <FAQ></FAQ>
    <Footer></Footer>
  </div>
</template>

<script setup lang="ts">
import { useViewStore } from "~/stores/ViewStore";

const scrollBtn = ref(false);
const isMobile = ref();
const viewStore = useViewStore();

useHead({
  title: "Podcast",
  meta: [
    {
      name: "description",
      content:
        "Unser Service bietet umfassende Unterstützung bei der Podcast-Erstellung, einschließlich Equipment-Beratung, Produktion und Betreuung. Darüber hinaus unterstützen wir bei der Monetarisierung, bieten Videopodcast-Optionen und kümmern uns um die Vermarktung.",
    },
  ],
});

onMounted(() => {
  window.scrollTo(0, 0);

  if (window.innerWidth < 992) {
    isMobile.value = true;
  }

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      scrollBtn.value = true;
    } else {
      scrollBtn.value = false;
    }
  }
});
</script>

<style lang="scss" scoped></style>
